import {
  IPostalAddressRepository,
  PostalAddress,
} from "../../../domain/contact";
import { AuthenticatedService } from "../..";
import { IPostalAddressBean } from "./beans";

export class PostalAddressRepository extends AuthenticatedService implements IPostalAddressRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getEntities(postalCodePrefix: string): Promise<PostalAddress[]> {
    if (!postalCodePrefix || !postalCodePrefix.match(/^\d{3}/)) {
      throw new Error("指定された郵便番号が不正です。先頭から最低3桁の数値が指定されてる必要があります。(" + postalCodePrefix + ")");
    }
    const url = "/api/contact/addresses";
    const result = await this.get(url, {
      params: {
        postalCode: postalCodePrefix.replace(/[^\d]/g, ""),
      }
    });
    return this.toPostalAddresses(result.data);
  }

  private toPostalAddresses(beans: IPostalAddressBean[]): PostalAddress[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toPostalAddress(bean));
  }

  private toPostalAddress(bean: IPostalAddressBean): PostalAddress {
    const item = new PostalAddress(bean.postalCode, bean.prefectureName, bean.municipalityName, bean.areaName);
    return Object.freeze(item);
  }
}
